module.exports = __webpack_public_path__ + "static/img/case_detail_06_1.3db015b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_06_1.png
// module id = 7M8H
// module chunks = 34